<template>
  <div>
    <Nav></Nav>
    <div class="container" style="min-height: 1000px">
      <div class="top">
        <!-- <img src= "../assets/images/newscenter/banner.png" alt=""> -->
      </div>
      <div :class="searchBarFixed == true ? 'navs isFixed' : 'navs'">
        <ul>
          <li :class="{ navActive: navIndex === 0 }" @click="scrollTo(0)">
            住房城乡建设行业
          </li>
          <li :class="{ navActive: navIndex === 1 }" @click="scrollTo(1)">
            交通运输行业
          </li>
          <li :class="{ navActive: navIndex === 2 }" @click="scrollTo(2)">
            食品安全行业
          </li>
          <li :class="{ navActive: navIndex === 3 }" @click="scrollTo(3)">
            医疗卫生行业
          </li>
          <li :class="{ navActive: navIndex === 4 }" @click="scrollTo(4)">
            其他行业
          </li>
        </ul>
      </div>
      <div class="con conss">
        <div class="con-li">
          <div class="li-top">
            <div class="le">
              <img src="../assets/images/newscenter/zhufang.png" alt="" />
              <span>住房城乡建设行业</span>
            </div>
            <div class="ri" @click="toList(1)">更多></div>
          </div>
          <div class="li-bottom" v-if="liveList.length > 0">
            <div
              class="bot1"
              v-for="(item, index) in liveList"
              :key="index"
              @click="toDetail(item.Id)"
            >
              <img :src="item.ImageUrl" alt="" />
              <div class="li-bottom-text">
                <p class="title">{{ item.Title }}</p>
                <p class="content">
                  {{item.Text}}
                </p>
                <p class="time">
                  <span v-if="item.GzhUrl != undefined && item.GzhUrl != ''">
                    <span class="bot-code iconfont icon-erweima"></span>
                    <img class="active-code" :src="item.GzhUrl" alt="" />
                  </span>
                  <span class="bot-code" v-else ></span>

                  {{ item.AddDateTime }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="con-li1" id="jiao" v-if="trafficList.length > 0">
          <div class="li-top">
            <div class="le">
              <img src="../assets/images/newscenter/jiaotong.png" alt="" />
              <span>交通运输行业</span>
            </div>
            <div class="ri" @click="toList(2)">更多></div>
          </div>
          <div class="li-bottom">
            <div
              class="bot1"
              v-for="(item, index) in trafficList"
              :key="index"
              @click="toDetail(item.Id)"
            >
              <img class="ban" :src="item.ImageUrl" alt="" />
              <div class="li-bottom-text">
                <p class="title">{{ item.Title }}</p>
                <p class="content">
                  {{item.Text}}
                </p>
                <p class="time">
                  <span v-if="item.GzhUrl != undefined && item.GzhUrl != ''">
                    <span class="bot-code iconfont icon-erweima"></span>
                    <img class="active-code" :src="item.GzhUrl" alt="" />
                  </span>
                  <span class="bot-code" v-else ></span>
                  {{ item.AddDateTime }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="con-li2" v-if="fdaList.length > 0">
          <div class="li-top">
            <div class="le">
              <img src="../assets/images/newscenter/shipin.png" alt="" />
              <span>食品安全行业</span>
            </div>
            <div class="ri" @click="toList(3)">更多></div>
          </div>
          <div
            class="li-bottom"
            v-for="(item, index) in fdaList"
            :key="index"
            @click="toDetail(item.Id)"
          >
            <div class="left">
              <img :src="item.ImageUrl" alt="" />
            </div>
            <div class="right">
              <p class="title">{{ item.Title }}</p>
              <!-- <p class="content">那么多分开来帮忙模像不像你尽快就开了接口福达合金发的客户端就能看拉你进来教你看健康理念考虑家门口了你就看看i11你看了你看考虑考虑哪里毛孔里看了看了接口就看见1接口块六年级你不看计划科技部吧就就吧1不氪金回家搬家你看那就看看考虑吉姆尼考虑看看1看就吧回家看吧1吧</p> -->
              <p class="content">{{ item.Text }}</p>
              <p class="time">
                {{ item.AddDateTime }}
                <span v-if="item.GzhUrl != undefined && item.GzhUrl != ''">
                    <span class="bot-code iconfont icon-erweima"></span>
                    <img class="active-code" :src="item.GzhUrl" alt="" />
                  </span>
                  <span class="bot-code" v-else ></span>
              </p>
              <hr />
              <div style="cursor: pointer"><p>了解详情</p></div>
            </div>
          </div>
        </div>
        <div class="con-li3" v-if="medList.length > 0">
          <div class="li-top">
            <div class="le">
              <img src="../assets/images/newscenter/yiliao.png" alt="" />
              <span>医疗卫生行业</span>
            </div>
            <div class="ri" @click="toList(4)">更多></div>
          </div>
          <div class="li-bottom">
            <div class="left">
              <img :src="medImg ? medImg : medList[0].ImageUrl" alt="" />
            </div>
            <div class="right">
              <div
                v-for="(item, index) in medList"
                :key="index"
                @click="toDetail(item.Id)"
                @mouseover="moveInMed(index)"
              >
                <p class="title" style="cursor: pointer">{{ item.Title }}</p>
                <!-- <p class="title">那么多分开来帮忙模像不像你尽快就开了接口福达合金发的客户端就能看拉你进来教你看健康理念考虑家门口了你就看看i11你看了你看考虑考虑哪里毛孔里看了看了接口就看见1接口块六年级你不看计划科技部吧就就吧1不氪金回家搬家你看那就看看考虑吉姆尼考虑看看1看就吧回家看吧1吧</p> -->
                <p class="time">
                  {{ item.AddDateTime }}

                  <span v-if="item.GzhUrl != undefined && item.GzhUrl != ''">
                    <span class="bot-code iconfont icon-erweima"></span>
                    <img class="active-code" :src="item.GzhUrl" alt="" />
                  </span>
                  <span class="bot-code" v-else ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="con-li3 con-li33" v-if="otherList.length > 0">
          <div class="li-top">
            <div class="le">
              <img src="../assets/images/newscenter/qita.png" alt="" />
              <span>其他行业</span>
            </div>
            <div class="ri" @click="toList(5)">更多></div>
          </div>
          <div class="li-bottom">
            <div class="left">
              <img :src="otherImg ? otherImg : otherList[0].ImageUrl" alt="" />
            </div>
            <div class="right">
              <div
                v-for="(item, index) in otherList"
                :key="index"
                @click="toDetail(item.Id)"
                @mouseover="moveInOther(index)"
              >
                <p class="title" style="cursor: pointer">{{ item.Title }}</p>
                <!-- <p class="title">那么多分开来帮忙模像不像你尽快就开了接口福达合金发的客户端就能看拉你进来教你看健康理念考虑家门口了你就看看i11你看了你看考虑考虑哪里毛孔里看了看了接口就看见1接口块六年级你不看计划科技部吧就就吧1不氪金回家搬家你看那就看看考虑吉姆尼考虑看看1看就吧回家看吧1吧</p> -->
                <p class="time">
                  {{ item.AddDateTime }}
                  <span v-if="item.GzhUrl != undefined && item.GzhUrl != ''">
                    <span class="bot-code iconfont icon-erweima"></span>
                    <img class="active-code" :src="item.GzhUrl" alt="" />
                  </span>
                  <span class="bot-code" v-else ></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Nav from '@/components/topNav.vue'
import Footer from '@/components/footer.vue'
export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      navIndex: 0,
      searchBarFixed: false,
      liveList: [],
      trafficList: [],
      fdaList: [],
      medList: [],
      otherList: [],
      medImg: '',
      otherImg: ''
    }
  },
  mounted () {
    let that = this
    window.addEventListener('scroll', this.onScroll, false)
    this.axios({
      method: 'GET',
      url: '/api/News/GetTops'
    })
      .then((result) => {
        // console.log(result, 'res')
        if (result.data.data.length > 0) {
          let data = result.data.data
          data.forEach(function (item, index) {
            if (item.IndustryType == 1) {
              if (that.liveList.length < 3) {
                that.liveList.push(item)
              }
            } else if (item.IndustryType == 2) {
              if (that.trafficList.length < 3) {
                that.trafficList.push(item)
              }
            } else if (item.IndustryType == 3) {
              if (that.fdaList.length < 3) {
                that.fdaList.push(item)
              }
            } else if (item.IndustryType == 4) {
              if (that.medList.length < 3) {
                that.medList.push(item)
              }
            } else if (item.IndustryType == 5) {
              that.otherList.push(item)
            }
          })
        }
      })
      .catch((err) => {
        console.log(err, 'err')
      })
  },
  methods: {
    toList (id) {
      // console.log(id, 'ids')
      this.$router.push({ path: '/newslist?id=' + id })
    },
    toDetail (id) {
      // console.log(id, 'id')
      this.$router.push('/newsdetail?id=' + id)
    },
    onScroll () {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.conss>div')
      // console.log(navContents, 'navContents')
      // console.log(navContents.length)
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []
      navContents.forEach((item) => {
        // console.log(item.offsetTop, 'top')
        offsetTopArr.push(item.offsetTop)
      })
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n + 1
        }
      }
      navIndex = navIndex >= navContents.length ? navIndex - 1 : navIndex
      // console.log(navIndex)
      this.navIndex = navIndex
      // 组件吸附顶部
      var offsetTop = document.querySelector('.navs').offsetTop
      // console.log(offsetTop, 'offsetTop')
      // console.log(scrollTop, 'scrollTop')
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true
      } else {
        // this.searchBarFixed = false
      }
      if (scrollTop < 380) {
        this.searchBarFixed = false
      }
    },
    scrollTo (index) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      // const foundEl = document.querySelector(`.home__content_comp div:nth-child(${index + 1})`);
      // const elClientHeight = foundEl.clientHeight
      const targetOffsetTop =
        document.querySelector(`.conss>div:nth-child(${index + 1})`).offsetTop -
        40
      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
      const STEP = 50
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
      } else {
        // 往下滑
        smoothDown()
      }
      // 定义往下滑函数
      function smoothDown () {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop - 100
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown)
        }
      }
      // 定义往上滑函数
      function smoothUp () {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP
          } else {
            scrollTop = targetOffsetTop
          }
          document.body.scrollTop = scrollTop
          document.documentElement.scrollTop = scrollTop - 50
          requestAnimationFrame(smoothUp)
        }
      }
    },
    moveInMed (idx) {
      let that = this
      // console.log(idx, 'idx')
      let medIndex = idx
      // console.log(that.medList[medIndex].ImageUrl, 'img')
      this.medImg = that.medList[medIndex].ImageUrl
      // this.medIndex = idx
    },
    moveInOther (idx) {
      let otherIndex = idx
      this.otherImg = this.otherList[otherIndex].ImageUrl
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style>
/* .container{
    min-height: 500px;
} */
.top {
  width: 100%;
  height: 300px;
  background-color: rgb(241, 180, 157);
  background: url("../assets/images/newscenter/banner.png") no-repeat center;
  overflow: hidden;
}

.navs {
  width: 100%;
  height: 56px;
  background: #fbfbfb;
}
.navs ul {
  width: 1200px;
  margin: 0px auto;
  /* background-color: orange; */
  display: flex;
  justify-content: space-between;
}
.navs ul li {
  list-style: none;
  float: left;
  line-height: 62px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  /* margin-right: 165px; */
  cursor: pointer;
}
.isFixed {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 999;
}
.navActive {
  color: #b00000 !important;
  background: url("../assets/images/newscenter/nav-top.png");
  background-repeat: no-repeat;
  background-position: center 48px;
}
.con {
  width: 1200px;
  margin: 0px auto;
}
.con .con-li .li-top {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.con .con-li .li-top .le img {
  width: 32px;
  height: 32px;
  vertical-align: -9px;
}
.con .con-li .li-top .le span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 8px;
}
.con .con-li .li-top .ri {
  margin: 5px 3px 0 0;
  cursor: pointer;
}
.con .con-li .li-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.con .con-li .li-bottom .bot1 {
  width: 383px;
  height: 340px;
  overflow: hidden;
  /* background-color: orange; */
  border: 1px solid #f1efef;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
  position: relative;
}
.con .con-li .li-bottom .bot1 .content {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-top: 8px;
  height: 0px;
   display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li .li-bottom .bot1:hover .li-bottom-text {
  top: 150px;
}
.con .con-li .li-bottom .bot1:hover .content {
  height: 56px;
}
.con .con-li .li-bottom .bot1:hover {
  box-shadow: 3px 5px 14px 2px rgba(98, 98, 98, 0.11);
}
.con .con-li .li-bottom .bot1:hover div .title {
  color: #b00000;
}
.con .con-li .li-bottom .bot1 img {
  width: 383px;
  height: 204px;
}
.con .con-li .li-bottom .bot1 div {
  padding: 0px 16px;
}
.con .con-li .li-bottom .bot1 .li-bottom-text {
  padding: 0px 16px;
  position: absolute;
  top: 204px;
  z-index: 99;
  width: 100%;
  background: #fff;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li .li-bottom .bot1 .li-bottom-text .title {
  height: 48px;
  /* background-color: orange; */
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  transition: all 1s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li .li-bottom .bot1 div .time {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #cccccc;
  margin-top: 34px;
  display: flex;
  justify-content: space-between;
}
.con .con-li .li-bottom .bot1 div .time img {
  width: 18px;
  height: 18px;
  vertical-align: 0px;
}
.con .con-li .li-bottom .bot1 .li-bottom-text .time .active-code {
  position: absolute;
  width: 120px;
  height: 120px;
  bottom: 30px;
  left: 21px;
  display: none;
}
.con
  .con-li
  .li-bottom
  .bot1
  .li-bottom-text
  .time
  .bot-code:hover
  + .active-code {
  display: inline-block !important;
}
.con .con-li1 .li-top {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.con .con-li1 .li-top .le img {
  width: 32px;
  height: 32px;
  vertical-align: -9px;
}
.con .con-li1 .li-top .le span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 8px;
}
.con .con-li1 .li-top .ri {
  margin: 5px 3px 0 0;
  cursor: pointer;
}
.con .con-li1 .li-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.con .con-li1 .li-bottom .bot1 {
  width: 383px;
  height: 340px;
  /* background-color: orange; */
  border: 1px solid #f1efef;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
  position: relative;
}
.con .con-li1 .li-bottom .bot1:hover {
  /* border: none; */
  box-shadow: 3px 5px 14px 2px rgba(98, 98, 98, 0.11);
}
.con .con-li1 .li-bottom .bot1 .ban {
  width: 100%;
  height: 204px;
  position: absolute;
  top: 0;
}

.con .con-li1 .li-bottom .bot1 .li-bottom-text {
  padding: 0px 16px;
  position: absolute;
  top: 204px;
  z-index: 99;
  width: 100%;
  background: #fff;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li1 .li-bottom .bot1 .li-bottom-text .title {
  height: 50px;
  font-size: 17px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li1 .li-bottom .bot1:hover div .title {
  color: #b00000;
}
.con .con-li1 .li-bottom .bot1 div .content {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-top: 8px;
  height: 0px;
   display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.con .con-li1 .li-bottom .bot1:hover .li-bottom-text {
  top: 150px;
}
.con .con-li1 .li-bottom .bot1:hover div .content {
  /* display: block; */
  height: 56px;
}
.con .con-li1 .li-bottom .bot1 div .time {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #cccccc;
  margin-top: 34px;
  display: flex;
  justify-content: space-between;
}
.con .con-li1 .li-bottom .bot1 div .time img {
  width: 18px;
  height: 18px;
  vertical-align: 0px;
}
.con .con-li1 .li-bottom .bot1 .li-bottom-text .time .active-code {
  position: absolute;
  width: 120px;
  height: 120px;
  bottom: 30px;
  left: 16px;
  display: none;
}
.con
  .con-li1
  .li-bottom
  .bot1
  .li-bottom-text
  .time
  .bot-code:hover
  + .active-code {
  display: inline-block !important;
}
.con .con-li2 .li-top {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.con .con-li2 .li-top .le img {
  width: 32px;
  height: 32px;
  vertical-align: -9px;
}
.con .con-li2 .li-top .le span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 8px;
}
.con .con-li2 .li-top .ri {
  margin: 5px 3px 0 0;
  cursor: pointer;
}
.con .con-li2 .li-bottom {
  width: 100%;
  height: 180px;
  /* background-color: orange; */
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 24px;
}
.con .con-li2 .li-bottom .left img {
  height: 180px;
  width: 300px;
}
.con .con-li2 .li-bottom .right {
  position: relative;
  width: 880px;
  height: 100%;
  /* background-color: pink; */
}
.con .con-li2 .li-bottom:hover {
  cursor: pointer;
}
.con .con-li2 .li-bottom .right .title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.con .con-li2 .li-bottom .right .content {
  height: 42px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-top: 10px;
}
.con .con-li2 .li-bottom .right .time {
  margin: 12px 0px 0px 5px;
}
.con .con-li2 .li-bottom .right .time .bot-code {
  width: 18px;
  height: 18px;
  vertical-align: -3px;
  margin-left: 25px;
  color: #b00000;
  cursor: pointer;
}
.con .con-li2 .li-bottom .right .time .active-code {
  position: absolute;
  width: 120px;
  height: 120px;
  bottom: 80px;
  left: 130px;
  display: none;
}
.con .con-li2 .li-bottom .right .time .bot-code:hover + .active-code {
  display: block;
}
.con .con-li2 .li-bottom .right hr {
  border: none;
  border-bottom: 2px solid #dedede;
  margin-top: 9px;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
}
.con .con-li2 .li-bottom:hover .right hr {
  /* border: none; */
  border-bottom: 2px solid #b00000;
}
.con .con-li2 .li-bottom .right div {
  width: 130px;
  height: 38px;
  margin-top: 14px;
  background: #eceef2;
  background-image: url("../assets/images/newscenter/center-more1.png");
  background-repeat: no-repeat;
  background-position: 87px 14px;
  background-size: 26%;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
}
.con .con-li2 .li-bottom:hover .right div {
  background: #b00000;
  background-image: url("../assets/images/newscenter/center-more.png");
  background-repeat: no-repeat;
  background-position: 87px 14px;
  background-size: 26%;
  transition: all 1.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
  }
.con .con-li2 .li-bottom .right div{
  width: 100px;
  height: 38px;
  margin-top: 14px;
  background: #ECEEF2;
  /* background-image:url('../assets/images/newscenter/center-more1.png');
  background-repeat:no-repeat;
  background-position: 87px 14px;
  background-size: 26%; */
  transition: all 1.5s cubic-bezier(.2,.8,.2,1);
     cursor: pointer;
     text-align: center;
}
.con .con-li2 .li-bottom:hover .right div{
  background:#B00000;
  /* background-image:url('../assets/images/newscenter/center-more.png');
  background-repeat:no-repeat;
  background-position: 87px 14px;
  background-size: 26%; */
  transition: all 1.5s cubic-bezier(.2,.8,.2,1);
     cursor: pointer;
}
.con .con-li2 .li-bottom .right div p {
  color: #999999;
  font-size: 13px;
  line-height: 38px;
  /* margin-left: 20px; */
}
.con .con-li2 .li-bottom:hover .right div p {
  color: #fff;
}
.con .con-li3 {
  margin-bottom: 50px;
}
.con .con-li3 .li-top {
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}

.con .con-li3 .li-top .le img {
  width: 32px;
  height: 32px;
  vertical-align: -9px;
}
.con .con-li3 .li-top .le span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin-left: 8px;
}
.con .con-li3 .li-top div {
  margin: 5px 3px 0 0;
  cursor: pointer;
}
.con .con-li3 .li-bottom {
  width: 100%;
  height: 320px;
  /* background-color: orange; */
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.con .con-li3 .li-bottom .left img {
  height: 320px;
  width: 480px;
}
.con .con-li3 .li-bottom .right {
  width: 690px;
  height: 100%;

  /* background-color: pink; */
  /* display: flex;
  flex-direction: column; */
}
.con .con-li3 .li-bottom .right div {
  transition: all 1s cubic-bezier(0.2, 0.8, 0.2, 1);
  margin-bottom: 12px;
  /* background-color: orange; */
  width: 100%;
  height: 72px;
  /* overflow: hidden; */
  padding-top: 7px;
  position: relative;
}
.con .con-li3 .li-bottom .right div:hover {
  box-shadow: 3px 5px 14px 2px rgba(98, 98, 98, 0.11);
}
.con .con-li3 .li-bottom .right div:hover .title {
  color: #b00000;
}
.con .con-li3 .li-bottom .right div .title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 0px 0px 0px 7px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.con .con-li3 .li-bottom .right div .time {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #cccccc;
  margin-top: 12px;
  margin-left: 7px;
}
.con .con-li3 .li-bottom .right div .time .bot-code {
  width: 18px;
  height: 18px;
  vertical-align: -2px;
  margin-left: 25px;
  color: #b00000;
  cursor: pointer;
}
.con .con-li3 .li-bottom .right div .time .active-code {
  position: absolute;
  width: 120px;
  height: 120px;
  bottom: 30px;
  left: 135px;
  display: none;
}
.con .con-li3 .li-bottom .right div .time .bot-code:hover + .active-code {
  display: block;
}
.con .con-li33{
  margin-bottom: 105px;
}
.icon-erweima{
  color: #d00000;
}
</style>



// WEBPACK FOOTER //
// src/views/newsCenter.vue